<template>

	<section id="Applications">

		<div id="Text">
			<h1>{{ $t('onlyOneIsPerfect') }}</h1>
			<h1>{{ $t('dontGuessXray') }}</h1>
			<p>{{ $t('zeissXraySeriesMake') }}</p>
		</div>

		<div id="Menu">

			<img src="/image/menu.png" usemap="#menumap" alt="Menu" />

			<map name="menumap">

				<area @click="showPopup(0)" shape="poly" coords="0,0,290,0,392,152,248,367" title="Plastics, Composites, Assemblies" alt="Plastics, Composites, Assemblies" />
				<area @click="showPopup(2)" shape="poly" coords="497,0,786,0,539,367,392,152" title="Alu Casting, Material Research, Life Sciences" alt="Alu Casting, Material Research, Life Sciences" />
				<area shape="poly" coords="392,152,539,367,392,582,248,367" title="Applications" alt="Applications" />
				<area @click="showPopup(1)" shape="poly" coords="248,367,392,582,290,734,0,734" title="Additive Manufacturing, Blade, Oil & Gas" alt="Additive Manufacturing, Blade, Oil & Gas" />
				<area @click="showPopup(3)" shape="poly" coords="539,367,786,734,496,734,392,582" title="Electronics, Battery" alt="Electronics, Battery" />

			</map>


			<div class="menu-el menu-el--plastics">

					{{ $t('plastics') }}

			</div>

			<div class="menu-el menu-el--composites">

					{{ $t('composites') }}

			</div>

			<div class="menu-el menu-el--assemblies">

					{{ $t('assemblies') }}

			</div>

			<div class="menu-el menu-el--alucasting">

					{{ $t('aluCasting') }}

			</div>

			<div class="menu-el menu-el--materialresearch">

					{{ $t('materialResearch') }}

			</div>

			<div class="menu-el menu-el--lifesciences">

					{{ $t('lifeSciences') }}

			</div>

			<div class="menu-el menu-el--additivemanufacturing">

					{{ $t('additiveManufacturing') }}

			</div>

			<div class="menu-el menu-el--blade">

					{{ $t('blade') }}

			</div>

			<div class="menu-el menu-el--oilgas">

					{{ $t('oilGas') }}

			</div>

			<div class="menu-el menu-el--aapplications">

				<img alt="Applications" src="/image/applications/applications.png" />

				{{ $t('applications') }}

			</div>

			<div class="menu-el menu-el--battery">

					{{ $t('battery') }}

			</div>

			<div class="menu-el menu-el--electronics">

					{{ $t('electronics') }}

			</div>

			<div class="menu-el menu-el--multi">

				{{ $t('multiMaterialParts') }}

			</div>

		</div>


		<div v-if="popupShow" class="application-popup">

			<div class="application-popup__close">

				<img src="/image/close.png" alt="Close" @click="popupShow = false" />

			</div>

			<div class="application-popup__title">

				{{ this.popupTitle }}

			</div>


			<div class="application-popup__image">

				<img :src="`/image/applications/${ popupNumber }.jpg`" :alt="popupTitle" />

			</div>


			<div class="application-popup__subtitle">

				{{ $t('dontGuessXray') }}

			</div>

			<div class="application-popup__description">

				{{ $t('zeissXraySeriesMake') }}

			</div>

		</div>

	</section>

</template>

<script>

	export default {
		data () {
			return {
				popupShow: false,
				popupTitle: null,
				popupNumber: null,
				popups: [
					{
						title: this.$t('onlyOneIsWillSave')
					},
					{
						title: this.$t('onlyOneIsBuilt')
					},
					{
						title: this.$t('onlyOneIsWillStay')
					},
					{
						title: this.$t('onlyOneIsWillKeep')
					}
				]
			}
		},
		methods: {
			showPopup (number) {
				this.popupNumber = number;
				this.popupTitle = this.popups[number].title;
				this.popupShow = true;
			}
		}
	};

</script>